import { yupResolver } from "@hookform/resolvers/yup";
import { Typography } from "@mui/material";
import {
  Form,
  FormStep,
  FormSubmit,
  InputField,
  PasswordField,
} from "@synota-io/synota-shared-ui";
import { useForm } from "react-hook-form";
import { Navigate, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { HOME_PATH } from "../../../paths";
import { useLogin } from "../../../api/hooks/useLogin";
import { useAuth } from "../../../api/auth/useAuth";

const schema = yup
  .object({
    email: yup.string().required("User is required"),
    password: yup.string().required("Password is required"),
  })
  .required();

export const LoginPage = () => {
  const navigate = useNavigate();

  const { isLogged } = useAuth();
  const { login, isPending } = useLogin();

  const form = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
    resolver: yupResolver(schema),
  });

  const onSubmit = form.handleSubmit((values) => {
    login(values, {
      onError: () => {
        form.setError("root", {
          message: "There was an unexpected error, please try again",
        });
      },
      onSuccess({ data }) {
        if (!data.error) {
          return navigate(HOME_PATH);
        }
        if (data.error_msg) {
          form.setError("root", { message: data.error_msg });
        }
      },
    });
  });

  if (isLogged) {
    return <Navigate to={HOME_PATH} />;
  }

  return (
    <Form onSubmit={onSubmit}>
      <FormStep>
        <InputField
          header="Email"
          fullWidth
          name="email"
          control={form.control}
        />
        <PasswordField
          header="Password"
          fullWidth
          name="password"
          control={form.control}
        />
        <FormSubmit isLoading={isPending} color="neutral">Login</FormSubmit>
      </FormStep>
      {form.formState.errors.root && (
        <Typography color="error" variant="body1">
          {form.formState.errors.root.message}
        </Typography>
      )}
    </Form>
  );
};
